<div class="modal fade" id="kt_modal_copy_freight_manager" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered mw-650px">
    <div class="modal-content">
      <div class="modal-header p-3 d-flex justify-content-between bg-secondary">
        <h2 class="fw-bold m-0">Copy Freight Manager Data</h2>
        <div class="btn btn-icon btn-sm btn-active-icon-primary" data-bs-dismiss="modal">
          <i class="ki-duotone ki-cross fs-1">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
        </div>
      </div>

      <form [formGroup]="copyForm" (ngSubmit)="onSubmit()">
        <div class="modal-body scroll-y mx-5 mx-xl-15 my-7">
          <div class="d-flex flex-column scroll-y me-n7 pe-7">

            <!-- From Month Year Section -->
            <div class="fv-row mb-7">
              <label class="required fw-semibold fs-6 mb-2">From Month Year</label>
              <div class="row g-3">
                <div class="col-md-6">
                  <select class="form-select form-select-solid" formControlName="fromMonth"
                          [class.is-invalid]="fromMonth?.invalid && fromMonth?.touched">
                    <option value="">Select Month</option>
                    <option *ngFor="let month of monthList" [value]="month.value">
                      {{ month.label }}
                    </option>
                  </select>
                  <div *ngIf="fromMonth?.invalid && fromMonth?.touched" class="invalid-feedback">
                    <div *ngIf="fromMonth?.errors?.['required']">From month is required</div>
                  </div>
                </div>
                <div class="col-md-6">
                  <select class="form-select form-select-solid" formControlName="fromYear"
                          [class.is-invalid]="fromYear?.invalid && fromYear?.touched">
                    <option value="">Select Year</option>
                    <option *ngFor="let year of yearList" [value]="year.value">
                      {{ year.label }}
                    </option>
                  </select>
                  <div *ngIf="fromYear?.invalid && fromYear?.touched" class="invalid-feedback">
                    <div *ngIf="fromYear?.errors?.['required']">From year is required</div>
                  </div>
                </div>
              </div>
            </div>

            <!-- To Month Year Section -->
            <div class="fv-row mb-7">
              <label class="required fw-semibold fs-6 mb-2">To Month Year</label>
              <div class="row g-3">
                <div class="col-md-6">
                  <select class="form-select form-select-solid" formControlName="toMonth"
                          [class.is-invalid]="toMonth?.invalid && toMonth?.touched">
                    <option value="">Select Month</option>
                    <option *ngFor="let month of monthList" [value]="month.value">
                      {{ month.label }}
                    </option>
                  </select>
                  <div *ngIf="toMonth?.invalid && toMonth?.touched" class="invalid-feedback">
                    <div *ngIf="toMonth?.errors?.['required']">To month is required</div>
                  </div>
                </div>
                <div class="col-md-6">
                  <select class="form-select form-select-solid" formControlName="toYear"
                          [class.is-invalid]="toYear?.invalid && toYear?.touched">
                    <option value="">Select Year</option>
                    <option *ngFor="let year of yearList" [value]="year.value">
                      {{ year.label }}
                    </option>
                  </select>
                  <div *ngIf="toYear?.invalid && toYear?.touched" class="invalid-feedback">
                    <div *ngIf="toYear?.errors?.['required']">To year is required</div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Info Message -->
            <div class="notice d-flex bg-light-info rounded border-info border border-dashed p-6">
              <i class="ki-duotone ki-information fs-2tx text-info me-4">
                <span class="path1"></span>
                <span class="path2"></span>
                <span class="path3"></span>
              </i>
              <div class="d-flex flex-stack flex-grow-1">
                <div class="fw-semibold">
                  <div class="fs-6 text-gray-700">
                    This will copy freight manager data from the selected source month/year to the destination month/year.
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-light" data-bs-dismiss="modal">Cancel</button>
          <button type="submit" class="btn btn-primary" [disabled]="isLoading">
            <span *ngIf="isLoading" class="spinner-border spinner-border-sm align-middle me-2"></span>
            <span *ngIf="isLoading">Copying...</span>
            <span *ngIf="!isLoading">Copy Data</span>
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
